/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Forside_Final_BodyInputs */

const da_forside_final_body = /** @type {(inputs: Forside_Final_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Opret en konto med din skole-mail. De første ${i?.count} besvarelser er gratis.`)
};

/** @type {(inputs: Forside_Final_BodyInputs) => LocalizedString} */
const en_forside_final_body = da_forside_final_body;

/**

* @param {Forside_Final_BodyInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_final_body = /** @type {((inputs: Forside_Final_BodyInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Final_BodyInputs, { locale?: "da" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_final_body(inputs)
	return da_forside_final_body(inputs)
});